// src/app/services/filter-util.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterUtilService {
filterPayload:any;
  buildFilterUrl(
    filteredElements: string[],
    orderedFilterData: any[],
    subCategories: any[],
    ranges: string[],
    rangeValues: Record<string, any>,
    filterData: any
  ): string {
    let filterUrl = "";

    for (const f of filteredElements) {
      if (!ranges.includes(f) && f !== "size" && !["class", "subcategory", "category"].includes(f)) {
        const checked = orderedFilterData.find(s => s.key === f)?.value
          ?.filter((e: any) => e.checked)
          .map((e: any) => e.value) || [];

        if (checked.length) filterUrl += `${f}:${checked.join(",")};`;
      }
      else if (f === "class") {
        const checked = orderedFilterData.find(s => s.key === "class")?.value
          ?.filter((e: any) => e.checked)
          .map((e: any) => e.value) || [];
        if (checked.length) filterUrl += `class:${checked.join(",")};`;
      }
      else if (ranges.includes(f)) {
        filterUrl += `${f}_from:${rangeValues[`${f}_from`]};${f}_to:${rangeValues[`${f}_to`]};`;
      }
    }

    // Add category if subCategories exist
    if (subCategories?.some(s => s.checked)) {
      const category = subCategories.filter(s => s.checked).map(s => s.category_id);
      if (category.length) filterUrl += `category:${category.join(",")};`;
    }

    return filterUrl;
  }

   parseFilterUrl(url: string): any[] {
  return url
    .split(';')                       // split into segments
    .filter(Boolean)                   // drop empty strings
    .map(segment => {
      const [key, val] = segment.split(/[:=]/); // support ':' or '='
      return { key: key.trim(), value: val.trim() };
    });
}

/** Extract just the unique keys from a filter URL */
 extractKeys(url: string): string[] {
  return [...new Set(this.parseFilterUrl(url).map(entry => entry.key))];
}
 
}
